import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components
import Badge from "components/Badge/Badge.jsx";
import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;

  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Our shopping centre team and partners  can give you a complete guide to acquiring and managing this type of asset.
          </h3>
          <p>
             This includes advice on how to purchase and enhance shopping centre assets, as well as agency and lease consultancy.
From day-to-day management to investment advice, we're well-known for our attention to detail. We pride ourselves on our market insight, and apply sector-specific expertise to all projects, working for major institutions, funds and private clients.

You can find our specialist partners in Madrid, Barcelona, Málaga. This broad coverage allows us to invest heavily in our resources, and ensures a wide-ranging and consistent level of service to our clients.
          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionDestacadas featured= {featured} url="mall" />
          <SectionRecents recents= {recents} url="mall" />
        </GridItem>

        <GridItem xs={12} sm={8} md={8} id="search" >
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
